const _ = require("lodash");

const customMeasure = function(rc, fontInfo, props, node, type) {
	const measureHandler = _.get(props, [type, node.name, "measure"]);
	const drawHandler = _.get(props, [type, node.name, "draw"]);
	if (
		typeof measureHandler !== "function" ||
		typeof drawHandler !== "function"
	) {
		rc.pushError(
			type +
				"'" +
				node.name +
				"' does not implement " +
				"both measuring and drawing."
		);
		rc.setErrored(node);
		return {};
	}
	const measure = measureHandler(rc, fontInfo, props, node);
	measure.drawHandler = drawHandler;
	return measure;
};

module.exports = {
	customCommand: {
		draw(rc, x, y, node, measure) {
			measure.drawHandler && measure.drawHandler(rc, x, y, node, measure);
		},
		measure(rc, fontInfo, props, node) {
			return customMeasure(rc, fontInfo, props, node, "customCommands");
		},
	},
	customEnvironment: {
		isBlock: true,
		draw(rc, x, y, node, measure) {
			measure.drawHandler && measure.drawHandler(rc, x, y, node, measure);
		},
		measure(rc, fontInfo, props, node) {
			return customMeasure(rc, fontInfo, props, node, "customEnvironments");
		},
	},
	customInlineEnvironment: {
		draw(rc, x, y, node, measure) {
			measure.drawHandler &&
				measure.drawHandler(rc, x, y - measure.top, node, measure);
		},
		measure(rc, fontInfo, props, node) {
			return customMeasure(rc, fontInfo, props, node, "customEnvironments");
		},
	},
};
